import { __ } from '../../../../translations';
import { playerTypes } from '../../../../config/constants';
import { GenericBitmovinPlayer } from '../../../player';
import Header from '../../../../components/ui/VodPlayer/Header';
import { createPortal } from 'react-dom';
import { iPlayTrailerProps } from '../../types/iDetailOverlay';

export const PlayTrailer: React.FC<iPlayTrailerProps> = ({
    playerContainerRef,
    showTrailer,
    trailerResolved,
    closeTrailerPlayer,
    item,
}) => {
    const closePlayer = () => {
        closeTrailerPlayer();
    };
    const onCompleted = () => {
        closeTrailerPlayer();
    };
    if (showTrailer && trailerResolved) {
        return createPortal(
            <div
                className="playerContainer"
                style={{
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    zIndex: '22',
                    backgroundColor: 'rgba(var(--primary-colors-rgb-background), .6)',
                    backdropFilter: 'blur(10px)',
                    pointerEvents: 'all',
                }}
                ref={playerContainerRef}
            >
                <GenericBitmovinPlayer
                    playerType={playerTypes.Trailer}
                    withSimpleUIInMinimizedMode
                    streamingUrl={trailerResolved}
                    onCompleted={onCompleted}
                    VODAsset={item}
                    header={<Header closePlayer={closePlayer} />}
                />
            </div>,
            document.body
        );
    }

    return <></>;
};
